import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Quantity Cell Renderer
 *
 * Renders multi-line quantity display with UMV, UMB, and conditional UMP
 *
 * @example
 * ```typescript
 * {
 *   field: 'stockConfirmedBase',
 *   headerName: 'Cantidad (U.M)',
 *   cellRenderer: QuantityCellRendererComponent,
 *   cellRendererParams: {
 *     getUMPActive: () => this.UMPActive
 *   },
 *   minWidth: 180
 * }
 * ```
 */
@Component({
  selector: 'app-stock-cell-renderer',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  template: `
    {{ params.data?.stockConfirmedERP | number : '1.3' }} ({{ params.data?.stockConfirmedUnitOfMeasure?.name }}) <br>
    <span class="f-9">
      <b>UMB:</b> {{ params.data?.stockConfirmedBase | number : '1.3' }} ({{ params.data?.baseUnitOfMeasure?.name }})<br>

      <ng-container *ngIf="isUMPActive">
        <b>UMP:</b>
        <ng-container *ngIf="params.data?.stockConfirmedPararell; else noUMP">
          {{ params.data?.stockConfirmedPararell | number : '1.3' }} ({{ params.data?.pararellUnitOfMeasure?.name }})
        </ng-container>
      </ng-container>
      <ng-template #noUMP> - </ng-template>
    </span>
  `,
})
export class StockCellRendererComponent implements CellRenderer<OrderDetailAttributes> {
  @Input() params!: CellRendererParams<OrderDetailAttributes>;

  get isUMPActive(): boolean {
    const getUMPActive = this.params.colDef?.cellRendererParams?.getUMPActive;
    return typeof getUMPActive === 'function' ? getUMPActive() : false;
  }
}
